<template>
  <!--使用标准模板-->
  <div class="create">
    <div class="main-box" v-loading="loadingTpl">
      <textarea id="tplEditor"></textarea>
    </div>

    <div class="aside-right">
      <h4>文件信息</h4>

      <el-form size="small" class="contract-info">
        <el-form-item>
          <p class="text-center" style="margin-bottom: 10px">文件名称</p>
          <el-input
            :value="tpl.tplName"
            placeholder="模板名称"
            :disabled="true"
            :readonly="true"
          />
        </el-form-item>
        <el-form-item>
          <el-button @click="nextStep()" type="danger" size="small" class="btn"
            >下一步</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            @click="$emit('turnFirst')"
            type="danger"
            plain
            size="small"
            class="btn"
            >上一步</el-button
          >
        </el-form-item>
        <!-- <el-form-item label="是否放入文件袋">
          <el-radio-group v-model="tpl.filePocket" @change="radioChange">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item>
          <p class="text-center">填写内容</p>
        </el-form-item>
        <div id="placeholderList" class="file-info-box">
          <el-form :model="tpl" ref="tplFrm" class="demo-dynamic">
            <div v-if="tpl.varList.length">
              <template v-for="(item, i) in tpl.varList">
                <el-form-item
                  :key="i"
                  :prop="'varList.' + i + '.varValue'"
                  v-if="item.varType === 0"
                  :rules="[
                    {
                      required: item.varIsMust,
                      message: '请输入文本',
                      trigger: 'change',
                    },
                    {
                      validator: $validator.maxLength,
                      maxLength: 64,
                      trigger: 'change',
                    },
                  ]"
                >
                  <el-input
                    @focus="placeholderAddStyle(item.varId)"
                    @blur="placeholderDelStyle(item.varId)"
                    @change.native="handleInputChange(i)"
                    :data-id="item.varId"
                    v-model="item.varValue"
                    type="text"
                    :placeholder="item.varName"
                  />
                </el-form-item>
                <el-form-item
                  :key="i"
                  :prop="'varList.' + i + '.varValue'"
                  v-if="item.varType === 1"
                  :rules="[
                    {
                      required: item.varIsMust,
                      message: '请输入数字',
                      trigger: 'change',
                    },
                    {
                      validator: $validator.number,
                      message: '请输入数值',
                      trigger: 'change',
                      emptyAble: true,
                    },
                    {
                      validator: $validator.maxLength,
                      maxLength: 32,
                      trigger: 'change',
                    },
                  ]"
                >
                  <el-input
                    @focus="placeholderAddStyle(item.varId)"
                    @blur="placeholderDelStyle(item.varId)"
                    @change="handleInputChange(i)"
                    :data-id="item.varId"
                    v-model="item.varValue"
                    type="text"
                    :placeholder="item.varName"
                  />
                </el-form-item>
                <el-form-item
                  :key="i"
                  :prop="'varList.' + i + '.varValue'"
                  v-if="item.varType === 2"
                  :rules="[
                    {
                      required: item.varIsMust,
                      message: '请输入日期',
                      trigger: 'change',
                    },
                    {
                      validator: $validator.regex,
                      regex: /^(\d{4}-\d{2}-\d{2})?$/,
                      message: '请选择正确的日期',
                      trigger: 'change',
                      emptyAble: true,
                    },
                  ]"
                >
                  <el-date-picker
                    @focus="placeholderAddStyle(item.varId)"
                    @blur="placeholderDelStyle(item.varId)"
                    @change="handleInputChange(i)"
                    popper-class="date-popper-cls"
                    value-format="yyyy-MM-dd"
                    align="left"
                    :data-id="item.varId"
                    v-model="item.varValue"
                    type="date"
                    :placeholder="item.varName"
                  />
                </el-form-item>
                <el-form-item
                  :key="i"
                  :prop="'varList.' + i + '.varValue'"
                  v-if="item.varType === 3"
                  :rules="[
                    {
                      required: item.varIsMust,
                      message: '请输入手机号',
                      trigger: 'change',
                    },
                    {
                      validator: $validator.mobile,
                      trigger: 'change',
                      emptyAble: true,
                    },
                    {
                      validator: $validator.maxLength,
                      maxLength: 20,
                      trigger: 'change',
                    },
                  ]"
                >
                  <el-input
                    @focus="placeholderAddStyle(item.varId)"
                    @blur="placeholderDelStyle(item.varId)"
                    @change="handleInputChange(i)"
                    :data-id="item.varId"
                    v-model="item.varValue"
                    type="text"
                    :placeholder="item.varName"
                  />
                </el-form-item>
                <el-form-item
                  :key="i"
                  :prop="'varList.' + i + '.varValue'"
                  v-if="item.varType === 4"
                  :rules="[
                    {
                      required: item.varIsMust,
                      message: '请输入身份证号',
                      trigger: 'change',
                    },
                    {
                      validator: $validator.idCard,
                      trigger: 'change',
                      emptyAble: true,
                    },
                  ]"
                >
                  <el-input
                    @focus="placeholderAddStyle(item.varId)"
                    @blur="placeholderDelStyle(item.varId)"
                    @change="handleInputChange(i)"
                    :data-id="item.varId"
                    v-model="item.varValue"
                    type="text"
                    :placeholder="item.varName"
                  />
                </el-form-item>
                <el-form-item
                  :key="i"
                  :prop="'varList.' + i + '.varValue'"
                  v-if="item.varType === 5"
                  :rules="[
                    {
                      required: item.varIsMust,
                      message: '请输入营业执照号',
                      trigger: 'change',
                    },
                    {
                      validator: $validator.businessLicenseVal,
                      trigger: 'change',
                      emptyAble: true,
                    },
                  ]"
                >
                  <el-input
                    @focus="placeholderAddStyle(item.varId)"
                    @blur="placeholderDelStyle(item.varId)"
                    @change="handleInputChange(i)"
                    :data-id="item.varId"
                    v-model="item.varValue"
                    type="text"
                    :placeholder="item.varName"
                  />
                </el-form-item>
                <el-form-item
                  :key="i"
                  :prop="'varList.' + i + '.varValue'"
                  v-if="item.varType === 6"
                  :rules="[
                    {
                      required: item.varIsMust,
                      message: '请输入统一社会编码格式',
                      trigger: 'change',
                    },
                    {
                      validator: $validator.businessLicenseVal,
                      trigger: 'change',
                      emptyAble: true,
                    },
                  ]"
                >
                  <el-input
                    @focus="placeholderAddStyle(item.varId)"
                    @blur="placeholderDelStyle(item.varId)"
                    @change="handleInputChange(i)"
                    :data-id="item.varId"
                    v-model="item.varValue"
                    type="text"
                    :placeholder="item.varName"
                  />
                </el-form-item>
                <el-form-item
                  :key="i"
                  :prop="'varList.' + i + '.varValue'"
                  v-if="item.varType === 7"
                  :rules="[
                    {
                      required: item.varIsMust,
                      message: '请输入邮箱',
                      trigger: 'change',
                    },
                    {
                      validator: $validator.email,
                      trigger: 'change',
                      emptyAble: true,
                    },
                    {
                      validator: $validator.maxLength,
                      maxLength: 64,
                      trigger: 'change',
                    },
                  ]"
                >
                  <el-input
                    @focus="placeholderAddStyle(item.varId)"
                    @blur="placeholderDelStyle(item.varId)"
                    @change="handleInputChange(i)"
                    :data-id="item.varId"
                    v-model="item.varValue"
                    type="text"
                    :placeholder="item.varName"
                  />
                </el-form-item>
              </template>
            </div>
          </el-form>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { ApiMethods } from "@/assets/js/http-serve/http-methods";

export default {
  props: {
    fileTplItem: {
      type: Object,
      default () {
        return {};
      }
    }
  },
  data () {
    return {
      templateAPI: ApiMethods.templateAPI,
      tpl: {
        tplId: null,
        context: "",
        serialNum: "",
        tplName: "",
        varList: [],
        filePocket: 0 // 是否放入文件袋
      },
      editor: null,
      loadingTpl: false
    };
  },
  computed: {
    isAuth () {
      return +this.$route.query.isAuth === 1;
    }
  },
  async mounted () {
    // this.editorOnHand()
  },
  created () {
    // this.tplId = this.$route.query.tplId;
  },
  methods: {
    // 获取详情
    getTPLInfo () {
      if (Object.keys(this.fileTplItem).length == 0) return false;
      const { tplVersion, tplIdSec } = this.fileTplItem;
      if (tplVersion === 2) return false;
      const param = {
        tplIdSec: tplIdSec
      };
      this.templateAPI.templateInfo(param).then(async res => {
        if (!res.success)
          return this.$message.error(res.description || this.$tip);
        this.tpl = res.data;
        this.tplId = res.data.tplId;
        // 如果 fileTplItem 有varList 字段说明是填写过。回显
        if (this.fileTplItem.varList)
          this.$set(this.tpl, "varList", this.fileTplItem.varList);
        await this.editorOnHand();
      });
    },
    // 原mounted 钩子函数执行的
    async editorOnHand () {
      let _this = this;
      let res = await _this.initCkeditor();
      // // 使用await等待ckEditor加载，然后再绑定事件
      res.editor.on("instanceReady", () => {
        _this.handleEditorReadyCallback(res.editor);
      });
      _this.editor = res.editor;
    },
    // * 是否放入文件袋
    // radioChange (e) {
    //   console.log(e)
    // },
    initCkeditor () {
      let _this = this;
      let { width: elW, height: elH } = document.body.getBoundingClientRect();
      let config = {
        language: "zh-cn",
        // fullPage: true,
        extraAllowedContent: "*(*);*{*}",
        ignoreEmptyParagraph: false,
        height: elH - 260 + "px",
        width: "100%",
        uiColor: "#E9E9E9",
        toolbar: [
          { name: "clipboard", items: ["Undo", "Redo"] },
          { name: "styles", items: ["Format", "Font", "FontSize"] },
          {
            name: "basicstyles",
            items: [
              "Bold",
              "Italic",
              "Underline",
              "Strike",
              "Subscript",
              "Superscript"
            ]
          },
          { name: "colors", items: ["TextColor", "BGColor"] },
          {
            name: "align",
            items: [
              "JustifyLeft",
              "JustifyCenter",
              "JustifyRight",
              "JustifyBlock"
            ]
          },
          {
            name: "paragraph",
            items: [
              "NumberedList",
              "BulletedList",
              "-",
              "Outdent",
              "Indent",
              "-",
              "Blockquote"
            ]
          },
          { name: "insert", items: ["Image", "Table", "HorizontalRule"] },
          { name: "wordimport", items: ["wordimport"] },
          { name: "tools", items: ["Maximize"] },
          { name: "document", items: ["Source"] }
        ],
        bodyClass: "document-editor",
        contentsCss: ["/ckeditor/contents.css", "/ckeditor/tpl_editor.css"],
        stylesSet: [
          /* Inline Styles */
          { name: "Marker", element: "span", attributes: { class: "marker" } },
          { name: "Cited Work", element: "cite" },
          { name: "Inline Quotation", element: "q" },
          /* Object Styles */
          {
            name: "Special Container",
            element: "div",
            styles: {
              padding: "5px 10px",
              background: "#eee",
              border: "1px solid #ccc"
            }
          },
          {
            name: "Compact table",
            element: "table",
            attributes: {
              cellpadding: "5",
              cellspacing: "0",
              border: "1",
              bordercolor: "#ccc"
            },
            styles: {
              "border-collapse": "collapse"
            }
          },
          {
            name: "Borderless Table",
            element: "table",
            styles: { "border-style": "hidden", "background-color": "#E6E6FA" }
          },
          {
            name: "Square Bulleted List",
            element: "ul",
            styles: { "list-style-type": "square" }
          }
        ],
        extraPlugins: "placeholder,notification,wordimport",
        toolbarCanCollapse: true,
        toolbarStartupExpanded: false
      };

      try {
        if (_this.editor === null) {
          _this.editor = CKEDITOR.replace("tplEditor", config);
          // 禁止编辑
          _this.editor.config.readOnly = false;
          _this.editor.config.bodyClass = "document-editor";
          _this.editor.config.contentsCss = [
            "/ckeditor/contents.css",
            "/ckeditor/tpl_editor.css"
          ];
          _this.editor.on("doubleclick", _this.handleEditorClik);
          // editor的onload事件
          // 使用promise来返回 editor
          return Promise.resolve({ editor: _this.editor });
        } else {
          return Promise.resolve({ editor: _this.editor });
        }
      } catch (error) {
        console.log(error);
      }
    },
    handleEditorReadyCallback (editor) {
      if (this.tplId) {
        this.isAuth
          ? this.loadAuthTpl(this.tplId, editor)
          : this.loadTpl(this.tplId, editor);
      }
    },
    matchVarList: function () {
      var _this = this;
      if (_this.editor && _this.tpl.varList.length > 0) {
        var widgets = _this.editor.widgets.instances;
        for (var index in widgets) {
          var wName = widgets[index].data.name;
          for (var i = 0; i < _this.tpl.varList.length; i++) {
            var varObj = _this.tpl.varList[i];
            if (wName == varObj.varName && !widgets[index].varId) {
              widgets[index].varId = varObj.varId;
              break;
            }
          }
        }
      }
    },
    placeholderAddStyle: function (varId) {
      this.matchVarList();
      let widgets = this.editor.widgets.instances;
      for (let key in widgets) {
        let widget = widgets[key];
        let Obj = widget.element;
        if (varId && widget.name === "placeholder" && widget.varId === varId) {
          Obj.setStyle("background", "#fce41c");
        }
      }
    },
    placeholderDelStyle (varId) {
      let widgets = this.editor.widgets.instances;

      for (let key in widgets) {
        let widget = widgets[key];
        let Obj = widget.element;
        if (varId && widget.name === "placeholder" && widget.varId === varId) {
          Obj.setStyle("background", "");
        }
      }
    },
    loadAuthTpl (tplId, editor) {
      let _this = this;
      _this.loadingTpl = true;
      if (editor) {
        editor.setData(this.tpl.context, {
          callback: () => {
            _this.matchVarList();
            editor.document.on("click", this.handleEditorClik);
          }
        });
      }
      _this.loadingTpl = false;
      return false;
      ApiMethods.TemplateController.authTplDetail({ tplId: tplId })
        .then(result => {
          if (result.success) {
            this.tpl = result.data;
            if (editor) {
              editor.setData(result.data.context, {
                callback: () => {
                  this.matchVarList();
                  editor.document.on("click", this.handleEditorClik);
                }
              });
            }
          } else {
            this.$message.error(result.description || this.$tip);
          }
        })
        .finally(() => {
          this.loadingTpl = false;
        });
    },
    loadTpl: function (tplId, editor) {
      this.loadingTpl = true;
      var _this = this;
      if (editor) {
        editor.setData(this.tpl.context, {
          callback: function () {
            _this.matchVarList();
            editor.document.on("click", _this.handleEditorClik);
          }
        });
      }
      _this.loadingTpl = false;
      return false;
      ApiMethods.TemplateController.findTpl({ tplId: tplId })
        .then(result => {
          if (result.success) {
            _this.tpl = result.data;
            if (editor) {
              editor.setData(result.data.context, {
                callback: function () {
                  _this.matchVarList();
                  editor.document.on("click", _this.handleEditorClik);
                }
              });
            }
          } else {
            _this.$message.error(result.description || this.$tip);
          }
        })
        .finally(() => {
          _this.loadingTpl = false;
        });
    },
    handleInputChange: function (idx) {
      let _this = this;
      _this.$refs.tplFrm.validateField(
        "varList." + idx + ".varValue",
        errorMessage => {
          if (!errorMessage || errorMessage == "") {
            var varObj = _this.tpl.varList[idx];
            let widgets = this.editor.widgets.instances;
            for (let key in widgets) {
              let widget = widgets[key];
              if (
                widget.name === "placeholder" &&
                widget.varId === varObj.varId
              ) {
                widget.setData("name", varObj.varValue || varObj.varName);
              }
            }
          }
        }
      );
    },
    handleEditorClik: function (el) {
      this.matchVarList();
      el =
        typeof el.data.getTarget == "function"
          ? el.data.getTarget()
          : el.data.element;
      if (el.hasClass("cke_placeholder")) {
        let varHtml = el.getHtml();
        let varName = varHtml.replace(/\[|\]/g, "");

        let widgets = this.editor.widgets.instances;
        for (let key in widgets) {
          let widget = widgets[key];
          if (widget.name === "placeholder" && widget.data.name === varName) {
            this.placeholderAddStyle(widget.varId);
            var input = document.querySelector(
              "#placeholderList input[data-id='" + widget.varId + "']"
            );
            var dateInput = document.querySelector(
              "#placeholderList [data-id='" + widget.varId + "'] input"
            );
            input = input || dateInput;
            if (input) {
              input.focus();
            }
          }
        }
      } else {
        this.placeholderAddStyle();
      }
    },
    checkForm () {
      return new Promise((resolve, reject) => {
        this.$refs.tplFrm.validate(valid => {
          // if (this.tpl.varList.length == 0) this.tpl.varList.finished = true;
          if (valid) {
            this.tpl.finished = true;
            resolve({ valid });
          } else {
            resolve({ valid });
          }
          // if end
        });
        // from validate end
      });
      // Promise end
    },
    nextStep: function () {
      this.checkForm().then(res => {
        if (!res.valid) return this.$message.error("请填写正确格式的变量内容");
        // if (this.tpl.varList.length == 0) this.tpl.varList.finished = true;
        const { varList, finished } = this.tpl;
        this.$emit("varListADD", { list: { varList, finished }, last: true });
      });
    }
  },
  watch: {
    fileTplItem: {
      handler (val) {
        if (val && val.tplVersion !== 2) {
          this.getTPLInfo();
        }
      },
      deep: true,
      immediate: true //立即执行
    }
  },
  name: "create"
};
</script>

<style lang="less" scoped>
.file-info-box {
  height: 50vh;
  overflow: auto;
}
.create {
  box-sizing: border-box;
  display: table;
  padding: 10px 20px;
  min-width: 1200px;

  .main-box,
  .aside-right {
    display: table-cell;
    vertical-align: top;
    box-sizing: border-box;
  }
}

.aside-right {
  width: 260px;
  min-width: 260px;
  border: 1px solid #d7d7d7;

  h4 {
    line-height: 300%;
    background-color: #f2f2f2;
    text-align: center;
  }

  .contract-info {
    box-sizing: border-box;
    padding: 20px;

    p {
      line-height: 1;
    }

    .btn {
      width: 100%;
    }
  }
}

.main-box {
  padding-right: 30px;
  width: 100%;
}

.date-popper-cls {
  width: 150px;
}
</style>



// WEBPACK FOOTER //
// pages/initiation/components/tplType/webTpl.vue